import React from "react";

function Heroicon({ icon, style }) {

    return (
        <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox={icon.startsWith('m') ? '0 0 20 20' : '0 0 24 24'} 
        fill={icon.startsWith('o') ? 'none' : 'currentColor'}
        strokeWidth={icon.startsWith('o') ? '1.5' : null}
        stroke={icon.startsWith('o') ? 'currentColor' : null}
        aria-hidden="true"
        className={style}
        >
            <use href={'#heroicon-' + icon} />
        </svg>
    );
}

export default Heroicon;